{
  "dismiss": "Отхвърляне"
}